import { ADDRESS_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/common/steps/AddressStep/constants';
import { DATA_JOIN_NOW_UPGRADE } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/common/steps/JoinNowStep/components/JoinNowUpgrade/constnts';
import { PREFERENCES_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/common/steps/PreferencesStep/constants';
import { PASSWORD_AND_EMAIL_CHANGE_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/upgrade/steps/ChangePhaseStep/components/PasswordAndEmailChangeStep/constants';
import { PASSWORD_CHANGE_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/upgrade/steps/ChangePhaseStep/components/PasswordChangeStep/constants';
import { NO_PIN_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/upgrade/steps/LoginUserStep/components/NoPinStep/constants';
import { PIN_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/upgrade/steps/LoginUserStep/components/PinStep/constants';
import { SECRETS_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/upgrade/steps/SecretsStep/constants';
import { TUpgradeData } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/upgrade/types';
import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';
import { STEP_NAMES } from '@interlayer/js/app/store/reducers/Registration/constants';

export const UPGRADE_DATA: TUpgradeData = {
    [STEP_NAMES.MEMBERSHIP_STEP]: DATA_JOIN_NOW_UPGRADE,
    [STEP_NAMES.PIN_STEP]: PIN_DATA,
    [STEP_NAMES.NO_PIN_STEP]: NO_PIN_DATA,
    [STEP_NAMES.PASSWORD_CHANGE_STEP]: PASSWORD_CHANGE_DATA,
    [STEP_NAMES.PASSWORD_AND_EMAIL_CHANGE_STEP]: PASSWORD_AND_EMAIL_CHANGE_DATA,
    [STEP_NAMES.TERMS_UPDATE_STEP]: {},
    [STEP_NAMES.USER_DETAILS_STEP]: {
        ...ADDRESS_DATA,
        [VALIDATION_FIELDS.phone]: ''
    },
    [STEP_NAMES.SECRETS_STEP]: SECRETS_DATA,
    [STEP_NAMES.UPDATE_PREFERENCES_STEP]: PREFERENCES_DATA
};

export const NUMBER_TERMS_UPDATE_STEP = 3;
export const NUMBER_SECRETS_STEP = 5;

export const UPGRADE_ORDERED_STEPS = [
    STEP_NAMES.MEMBERSHIP_STEP,
    [STEP_NAMES.PIN_STEP, STEP_NAMES.NO_PIN_STEP],
    [STEP_NAMES.PASSWORD_CHANGE_STEP, STEP_NAMES.PASSWORD_AND_EMAIL_CHANGE_STEP],
    [STEP_NAMES.TERMS_UPDATE_STEP],
    STEP_NAMES.USER_DETAILS_STEP,
    STEP_NAMES.SECRETS_STEP,
    STEP_NAMES.UPDATE_PREFERENCES_STEP
];
